// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetPoolAlertChannelBody = {
  poolId: string;
  alertKind:
    | "contestStarted"
    | "contestFinished"
    | "seasonStarted"
    | "poolSettingsChanged"
    | "pickReminder"
    | "roundGraded"
    | "eliminated"
    | "revived"
    | "spreadMoved"
    | "customAwardChanged"
    | "squaresLockUnlock"
    | "squaresGridPublished"
    | "squaresWinnerSet"
    | "squaresWinnerUpdated"
    | "squaresSquareAssigned"
    | "squaresScoreCorrection"
    | "stripCardLockUnlock"
    | "memberWaitingApproval"
    | "roundLocked"
    | "contestCorrected"
    | "stripCardStripAdded"
    | "stripCardFilled"
    | "stripCardSpotAssigned"
    | "stripCardSpotUnassigned"
    | "stripCardWinner"
    | "stripCardGameCanceled";
  channel: "email" | "inApp" | "phone";
  isEnabled: boolean;
};

export type typeNotificationSettingsSetPoolAlertChannelOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    poolId: string;
    followsGlobal: boolean;
    alertKind:
      | "contestStarted"
      | "contestFinished"
      | "seasonStarted"
      | "poolSettingsChanged"
      | "pickReminder"
      | "roundGraded"
      | "eliminated"
      | "revived"
      | "spreadMoved"
      | "customAwardChanged"
      | "squaresLockUnlock"
      | "squaresGridPublished"
      | "squaresWinnerSet"
      | "squaresWinnerUpdated"
      | "squaresSquareAssigned"
      | "squaresScoreCorrection"
      | "stripCardLockUnlock"
      | "memberWaitingApproval"
      | "roundLocked"
      | "contestCorrected"
      | "stripCardStripAdded"
      | "stripCardFilled"
      | "stripCardSpotAssigned"
      | "stripCardSpotUnassigned"
      | "stripCardWinner"
      | "stripCardGameCanceled";
    channel: "email" | "inApp" | "phone";
    isEnabled: boolean;
  };
};

export type typeNotificationSettingsSetPoolAlertChannelOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetPoolAlertChannelOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetPoolAlertChannelOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetPoolAlertChannelBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    alertKind: {
      type: "string",
      enum: [
        "contestStarted",
        "contestFinished",
        "seasonStarted",
        "poolSettingsChanged",
        "pickReminder",
        "roundGraded",
        "eliminated",
        "revived",
        "spreadMoved",
        "customAwardChanged",
        "squaresLockUnlock",
        "squaresGridPublished",
        "squaresWinnerSet",
        "squaresWinnerUpdated",
        "squaresSquareAssigned",
        "squaresScoreCorrection",
        "stripCardLockUnlock",
        "memberWaitingApproval",
        "roundLocked",
        "contestCorrected",
        "stripCardStripAdded",
        "stripCardFilled",
        "stripCardSpotAssigned",
        "stripCardSpotUnassigned",
        "stripCardWinner",
        "stripCardGameCanceled",
      ],
    },
    channel: { type: "string", enum: ["email", "inApp", "phone"] },
    isEnabled: { type: "boolean" },
  },
  required: ["poolId", "alertKind", "channel", "isEnabled"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetPoolAlertChannel(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsSetPoolAlertChannelBody,
    );
  }

  return async function postNotificationSettingsSetPoolAlertChannel(
    payload: typeNotificationSettingsSetPoolAlertChannelBody,
  ): Promise<
    | typeNotificationSettingsSetPoolAlertChannelOutput200
    | typeNotificationSettingsSetPoolAlertChannelOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetPoolAlertChannel" failed before calling the network. #d38ce017fa84`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d38ce017fa84" },
        },
        data: null,
      } as typeNotificationSettingsSetPoolAlertChannelOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-pool-alert-channel`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetPoolAlertChannelOutput200
      | typeNotificationSettingsSetPoolAlertChannelOutput400;
  };
}
